import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { ProductReveal } from './components/ProductReveal';
import { ModulesSection } from './components/ModulesSection';
import { BonusSection } from './components/BonusSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { AudienceSection } from './components/AudienceSection';
import { PricingSection } from './components/PricingSection';
import { Footer } from './components/Footer';
import { SectionDivider } from './components/ui/SectionDivider';
export function App() {
  return <main className="min-h-screen bg-navy-900 text-cream-200 font-body selection:bg-gold-500 selection:text-navy-900" data-id="element-0">
      <HeroSection data-id="element-1" />
      <SectionDivider data-id="element-2" />

      <ProblemSection data-id="element-3" />
      <SectionDivider data-id="element-4" />

      <ProductReveal data-id="element-5" />
      <SectionDivider data-id="element-6" />

      <ModulesSection data-id="element-7" />
      <SectionDivider data-id="element-8" />

      <BonusSection data-id="element-9" />
      <SectionDivider data-id="element-10" />

      <TestimonialsSection data-id="element-11" />
      <SectionDivider data-id="element-12" />

      <AudienceSection data-id="element-13" />
      <SectionDivider data-id="element-14" />

      <PricingSection data-id="element-15" />

      <Footer data-id="element-16" />
    </main>;
}